import "./alert.dialog.css"
import AlertDialog from "./AlertDialog"
import AlertDialogAction from "./AlertDialogAction"
import AlertDialogCancel from "./AlertDialogCancel"
import AlertDialogDescription from "./AlertDialogDescription"
import AlertDialogFooter from "./AlertDialogFooter"
import AlertDialogTitle from "./AlertDialogTitle"
import AlertDialogTrigger from "./AlertDialogTrigger"
import AlertDialogContent from "./AlertDialogContent"
import AlertDialogHeader from "./AlertDialogHeader"

export type { AlertDialogProps } from "./AlertDialog"
export type { AlertDialogActionProps } from "./AlertDialogAction"
export type { AlertDialogCancelProps } from "./AlertDialogCancel"
export type { AlertDialogDescriptionProps } from "./AlertDialogDescription"
export type { AlertDialogFooterProps } from "./AlertDialogFooter"
export type { AlertDialogTitleProps } from "./AlertDialogTitle"
export type { AlertDialogTriggerProps } from "./AlertDialogTrigger"
export type { AlertDialogContentProps } from "./AlertDialogContent"
export type { AlertDialogHeaderProps } from "./AlertDialogHeader"

export default Object.assign(AlertDialog, {
  Action: AlertDialogAction,
  Cancel: AlertDialogCancel,
  Description: AlertDialogDescription,
  Footer: AlertDialogFooter,
  Title: AlertDialogTitle,
  Trigger: AlertDialogTrigger,
  Content: AlertDialogContent,
  Header: AlertDialogHeader,
})
